import { render, staticRenderFns } from "./WorkIconTableLayout.vue?vue&type=template&id=effe9bca"
import script from "./WorkIconTableLayout.vue?vue&type=script&lang=js"
export * from "./WorkIconTableLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports